
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audio",
      function () {
        return require("private-next-pages/audio/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/audio"])
      });
    }
  